import { HiChevronDoubleLeft, HiChevronDoubleRight } from 'react-icons/hi';
import Wrapper from '../../assets/wrappers/PageBtnContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAllMessagesContext } from '../../pages/ShowMessages';

const MessagePaginationContainer = () => {
  const {
    data: { numOfPages, currentPage },
  } = useAllMessagesContext();

  const pages = Array.from({ length: numOfPages }, (_, i) => i + 1);
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set('page', pageNumber);
    navigate(`${pathname}?${searchParams.toString()}`);
  };

  const addPageButton = (pageNumber, activeClass) => (
    <button
      key={pageNumber}
      onClick={() => handlePageChange(pageNumber)}
      className={`btn page-btn ${activeClass ? 'active' : ''}`}
    >
      {pageNumber}
    </button>
  );

  return (
    <Wrapper>
      <button
        className='btn prev-btn'
        onClick={() => handlePageChange(currentPage > 1 ? currentPage - 1 : numOfPages)}
      >
        <HiChevronDoubleLeft />
        הקודם
      </button>

      <div className='btn-container'>
        {pages.map((page) =>
          addPageButton(page, page === currentPage)
        )}
      </div>

      <button
        className='btn next-btn'
        onClick={() => handlePageChange(currentPage < numOfPages ? currentPage + 1 : 1)}
      >
        הבא
        <HiChevronDoubleRight />
      </button>
    </Wrapper>
  );
};

export default MessagePaginationContainer;
